import { render, staticRenderFns } from "./SaleHistoryEvent.vue?vue&type=template&id=5bb937e3&scoped=true"
import script from "./SaleHistoryEvent.vue?vue&type=script&lang=ts"
export * from "./SaleHistoryEvent.vue?vue&type=script&lang=ts"
import style0 from "./SaleHistoryEvent.vue?vue&type=style&index=0&id=5bb937e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb937e3",
  null
  
)

export default component.exports